import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import style from './ErrorPage.module.scss';
import PageWrapper from '../../components/PageWrapper';
import { getSiteUrl } from '../../helpers/getMainSiteUrl';
import text from '../../text';

const cx = classNames.bind(style);

export function ErrorPage() {
  const mainSiteUrl = useMemo(getSiteUrl, []);
  const { errorPage } = text;

  return (
    <PageWrapper dataTestId="error-page">
      <h2 className={cx('title')} data-testid="error-page-title">
        {errorPage.title}
      </h2>
      <p className={cx('content')}>{errorPage.content}</p>

      {mainSiteUrl && (
        <a
          href={mainSiteUrl}
          className={cx('button')}
          data-testid="error-page-link"
        >
          {errorPage.backToHome}
        </a>
      )}
    </PageWrapper>
  );
}
